import { API, Router } from "../../components/Helpers";
import React from "react";

export const useTours = ({ sort_by, location, tours: _tours, request, specific_tours, routes, active_site, domain }) => {

    const [tours, setTours] = React.useState(_tours);
    const [loadingTours, setLoadingTours] = React.useState(false);
    const pagination = tours.meta.pagination;


    const urlParams = (page) => {
        let params = _.omit(request, 'page');

        params = _.assign({
            include: 'tags',
            location: location.slug,
            sort_by: sort_by.slug,
            status: 'Published'
        }, params);

        if (page > 1) {
            params = _.assign({ page }, params);
        }

        return params;
    }

    const loadMoreTours = (page) => {
        const router = Router(routes);

        let payload = urlParams(page);

        let onResponse = {
            success: (response) => {
                setTours({
                    meta: response.meta,
                    data: tours.data.concat(response.data)
                });
                setLoadingTours(false);

            },
            error: error => {
                console.log('error', error);
            },
            complete: () => {
                console.log('complete');
            }
        }


        const requestUrl = router.url('getTours', { domain, ...payload });

        setLoadingTours(true);

        try {
            API.get(onResponse, requestUrl);
        } catch (err) {
            console.log(err)
        }

    }


    const defineState = () => {
        let _state = {
            get specificTours() {
                return specific_tours;
            },
            get tourListingCtaText() {
                let tour_listing_cta_text = _.find(active_site.settings.data, (_setting) => { return _setting.key == 'tour_listing_cta_text'; });

                if (!_.isEmpty(tour_listing_cta_text)) {
                    return tour_listing_cta_text.value;
                }
            },
            loadMoreTours,
            urlParams
        };
        if (typeof state === 'object')
            _state = state;

        return {
            ..._state,
            loadingTours,
            tours,
            get() {
                return tours.data;
            },
            get hasTours() {
                return !_.isEmpty(tours.data);
            },
            get toursToCount() {
                return pagination.current_page * pagination.per_page < pagination.total ? pagination.current_page * pagination.per_page : pagination.total;
            },
            get totalTours() {
                return pagination.total;
            },
            get currentPage() {
                return pagination.current_page
            },
            get totalPages() {
                return pagination.total_pages
            },
            get perPage() {
                return pagination.per_page
            },
            get nextCount() {
                if ((pagination.total - (pagination.current_page * pagination.per_page)) < pagination.per_page) return pagination.total - (pagination.current_page * pagination.per_page);
                return pagination.per_page;
            }
        };
    }
    const [state, setState] = React.useState(defineState());


    React.useEffect(() => setState(defineState()), [tours, loadingTours]);

    return state;
}


// WEBPACK FOOTER //
// ./resources/js/react/hooks/useTours.js